import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserModule } from './core/user/user.module';
import { NotificationModule } from './notification/notification.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeModule } from './home/home.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { SettingsModule } from './settings/settings.module';
@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  imports: [
    HomeModule,
    BrowserModule,
    FormsModule,
    NotificationModule,
    UserModule,
    AppRoutingModule,
    SettingsModule
  ],
  providers: [CookieService, provideAnimationsAsync()],
  bootstrap: [AppComponent],
})
export class AppModule {}
